/* eslint-disable no-console */
import {ArrowLeftOutlined} from '@ant-design/icons';
import {Form, Input, Button, Typography} from 'antd';
import React, {useState} from 'react';

import {verifyEmailAndSendOTP} from '../../../services/modules/User/forgotPassword';
import {errorMessages} from '../../signUp/Constants/errorMessages';
import {IEmailFormData} from '../Utils/Interfaces';

const {Title, Text} = Typography;

interface IFormData {
  email: string;
}

const ValidateEmailScreen: React.FC<IEmailFormData> = ({
  onFinish,
  callbackUrl
}) => {
  const [form] = Form.useForm();
  const [isFormValid, setIsFormValid] = useState(false);
  const [buttonAction, setButtonAction] = useState<boolean>();

  const forgotPasswordDescription = // eslint-disable-next-line
    "Don't worry! Enter your registered email and we'll send you a one-time password (OTP) to reset it.";

  const handleFinish = async (values: IFormData) => {
    setButtonAction(true);
    await verifyEmailAndSendOTP({
      email: `${values?.email}`
    })
      .then((data) => {
        setButtonAction(false);
        if (data?.status === 'error' && data?.errorType === 'USER_EMAIL') {
          const message = data.message;
          form.setFields([
            {
              name: 'email',
              errors: [message]
            }
          ]);
        } else if (data.status === 'success') {
          onFinish(values?.email);
        }
      })
      .catch(() => {
        setButtonAction(false);
      });
  };

  const onValuesChange = () => {
    validateForm();
  };

  const validateForm = () => {
    const hasErrors = form
      .getFieldsError()
      .some(({errors}) => errors.length > 0);
    const allTouched = form.isFieldsTouched(true);
    setIsFormValid(!hasErrors && allTouched);
  };

  return (
    <>
      <Title level={3} style={{textAlign: 'left', marginBottom: 8}}>
        Forgot your password?
      </Title>
      <Text
        type="secondary"
        style={{display: 'block', textAlign: 'left', marginBottom: 15}}
      >
        {forgotPasswordDescription}
      </Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={(values) => {
          void handleFinish(values);
        }}
        onValuesChange={onValuesChange}
        onFieldsChange={validateForm} // to catch blur validations
      >
        <Form.Item
          name="email"
          label="Email address"
          rules={[
            {
              validator: async (_, value) => {
                if (!value || value.trim() === '') {
                  throw new Error(`${errorMessages.requiredEmail}`);
                }
                const fullEmail = `${value || ''}`;
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                await Promise.resolve();

                if (!emailRegex.test(fullEmail)) {
                  throw new Error(`${errorMessages.invalidEmail}`);
                }
              }
            }
          ]}
          required={false}
          validateTrigger={['onBlur', 'onChange']}
        >
          <Input />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            block
            disabled={!isFormValid}
            style={{
              backgroundColor: '#159a84',
              borderRadius: 8,
              height: 44,
              fontWeight: 600
            }}
            loading={buttonAction}
          >
            {buttonAction ? 'Verifying' : 'Send OTP'}
          </Button>
        </Form.Item>
        <div style={{textAlign: 'center'}}>
          <Button
            type="link"
            style={{color: 'black', fontWeight: '600'}}
            icon={<ArrowLeftOutlined />}
            href={callbackUrl}
          >
            Back to Login
          </Button>
        </div>
      </Form>
    </>
  );
};

export default ValidateEmailScreen;
